var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "contents_wrap" }, [
      ["001", "002"].includes(_vm.gubunCd)
        ? _c("div", [
            _c("h2", { staticClass: "pg_title" }, [
              _vm._v("Second Approval Detail (Access Request)")
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic")]),
            _vm._v(" "),
            _c("table", { staticClass: "create_table" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.requestData.NAME))]),
                  _vm._v(" "),
                  _c("th", [_vm._v("English Name")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.requestData.ENAME))])
                ]),
                _vm._v(" "),
                _vm.requestData.COUNTRY_NAME
                  ? _c("tr", [
                      _c("th", [_vm._v("Country/Region")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.requestData.COUNTRY_NAME))]),
                      _vm._v(" "),
                      _c("th"),
                      _vm._v(" "),
                      _c("td")
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn_wrap_full topLine" }),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "sub_tit mt40" }, [_vm._v("Role")]),
              _vm._v(" "),
              _c("table", { staticClass: "create_table" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("User Role")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getRoleName))])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn_wrap_full topLine" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sub_tit mt40" }, [_vm._v("Additional")]),
            _vm._v(" "),
            _c("table", { staticClass: "create_table" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("Purpose")]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(_vm.requestData.PURPOSE))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn_wrap_full topLine" }),
            _vm._v(" "),
            _c("div", { staticClass: "sub_tit mt40" }, [
              _vm._v("Approval Information")
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "create_table" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("First Approver")]),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.firstApproverUserId,
                          expression: "firstApproverUserId"
                        }
                      ],
                      staticClass: "text_input",
                      attrs: {
                        type: "text",
                        placeholder: "",
                        maxlength: "30",
                        readonly: "readonly"
                      },
                      domProps: { value: _vm.firstApproverUserId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.firstApproverUserId = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                ["A04", "A05", "A08", "A09"].includes(_vm.requestData.ROLE_CD)
                  ? _c("tr", [
                      _c("th", [_vm._v("Mac Address")]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.macAddress,
                              expression: "macAddress"
                            }
                          ],
                          staticClass: "text_input",
                          attrs: {
                            type: "text",
                            placeholder: "",
                            maxlength: "30",
                            readonly: "readonly"
                          },
                          domProps: { value: _vm.macAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.macAddress = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _c("div", [
            _c("h2", { staticClass: "pg_title" }, [
              _vm._v("Second Approval View (Other)")
            ]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic")]),
            _vm._v(" "),
            _c("table", { staticClass: "create_table" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("Name")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.requestData.NAME))]),
                  _vm._v(" "),
                  _c("th", [_vm._v("English Name")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.requestData.ENAME))])
                ]),
                _vm._v(" "),
                _vm.requestData.COUNTRY_NAME
                  ? _c("tr", [
                      _c("th", [_vm._v("Country/Region")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.requestData.COUNTRY_NAME))]),
                      _vm._v(" "),
                      _c("th"),
                      _vm._v(" "),
                      _c("td")
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn_wrap_full topLine" }),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "sub_tit mt40" }, [
                _vm._v("Request Information")
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "create_table" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("Request Type")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.selectedRequestTypeName))])
                  ]),
                  _vm._v(" "),
                  _c("tr"),
                  _vm._v(" "),
                  ["003", "004"].includes(_vm.requestData.TYPE_CD)
                    ? _c("tr", [
                        _c("th", [_vm._v("ESN/IMEI Writing P/W")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("******************")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  ["006", "007"].includes(_vm.requestData.TYPE_CD)
                    ? _c("tr", [
                        _c("th", [_vm._v("Country/Region")]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedCountry,
                                  expression: "selectedCountry"
                                },
                                { name: "validation", rawName: "v-validation" }
                              ],
                              staticClass: "slt_white w-40",
                              attrs: {
                                disabled: ["004", "005"].includes(_vm.reqStatus)
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedCountry = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.availableCountryList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.CODE_ID,
                                  domProps: { value: item.CODE_ID }
                                },
                                [_vm._v(_vm._s(item.CODE_NAME))]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  ["008"].includes(_vm.requestData.TYPE_CD)
                    ? _c("tr", [
                        _c("th", [_vm._v("User Role")]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedUserRole,
                                  expression: "selectedUserRole"
                                }
                              ],
                              staticClass: "slt_white w100",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedUserRole = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.availableUserRoleList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: item.CODE_ID,
                                  domProps: { value: item.CODE_ID }
                                },
                                [_vm._v(_vm._s(item.CODE_NAME))]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Purpose")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.requestData.PURPOSE))])
                  ])
                ])
              ])
            ])
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn_wrap_full topLine" }, [
        _c(
          "a",
          {
            staticClass: "btn_white",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.onBackToList()
              }
            }
          },
          [_vm._v("List")]
        ),
        _vm._v(" "),
        _vm.requestData.STAT_CD === "002"
          ? _c("div", { staticClass: "btn_right" }, [
              _c(
                "a",
                {
                  staticClass: "btn_white",
                  attrs: { href: "javascript:", title: "" },
                  on: { click: _vm.onApproveClick }
                },
                [_vm._v("Approve")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn_blue",
                  attrs: { href: "javascript:", title: "" },
                  on: { click: _vm.onRejectClick }
                },
                [_vm._v("Reject")]
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n                Home\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Engineer\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Mobile SVC\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Second Approval Detail (Access Request)\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bc_ico" }, [
      _vm._v("\n                Home\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Engineer\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Mobile SVC\n                "),
      _c("em", [_c("span", { staticClass: "sr_only" }, [_vm._v(">")])]),
      _vm._v(" Second Approval View (Other)\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "18%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f633fac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f633fac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/approvalManagement/SecondApprovalView.vue
// module id = mowQ
// module chunks = 0